import { Pipe, PipeTransform } from '@angular/core';
import { GlobalService } from '../_services/global.service';

@Pipe({
  name: 'currencySymbol',
  pure: true
})
export class CurrencySymbolPipe implements PipeTransform {
  transform(): string {
    return GlobalService.getCurrencySymbol();
  }
}
